import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import CascadeMasterTable from "./CascadeMasterTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_CASCADE_MASTER_DOWNLOAD_API,
  LONG_CASCADE_MASTER_GET_API,
  LONG_CASCADE_UPDATE_DATA_API,
  LONG_FACILITY_MASTER_GET_API,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function CascadeMaster(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFacilityCode, setSelectFacilityCode] = useState<any>("");
  const [selectFacilityType, setSelectFacilityType] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectFacilityDescription, setSelectFacilityDescription] =
    useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [facilityCodeOptions, setFacilityCodeOptions] = React.useState([]);
  const [facilityTypeOptions, setFacilityTypeOptions] = useState<any>([]);
  const [flagOptions, setFlagOptions] = useState<any>([]);
  const [selectflag, setSelectFlag] = useState<any>("");
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [facilityDescriptionOptions, setFacilityDescriptionOptions] =
    useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "facility_Type", value: "" },
    { key: "facility_Code", value: "" },
    { key: "facility_Description", value: "" },
    { key: "[cascade]", value: "" },
    { key: "flag", value: "" },
  ]);

  const facilityCodeNames = facilityCodeOptions?.sort((a: any, b: any) => {
    const codeA = a?.facility_Code ?? "";
    const codeB = b?.facility_Code ?? "";
    return codeA.localeCompare(codeB);
  });

  const facilityDescriptionNames = facilityDescriptionOptions?.sort(
    (a: any, b: any) => {
      const descA = a?.facility_Description ?? "";
      const descB = b?.facility_Description ?? "";
      return descA.localeCompare(descB);
    }
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };
  var line = 0;
  var base = 0;

  var code = 0;
  var cascade = 0;
  var description = 0;
  var type = 0;
  var flag = 0;

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_CascadeMaster_LT"
  );

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_CascadeMaster_LT_Module2");
      getfiltersApi("tblScenario_CascadeMaster_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_CascadeMaster_LT_Module3");
      getfiltersApi("tblScenario_CascadeMaster_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_CascadeMaster_LT_Module4");
      getfiltersApi("tblScenario_CascadeMaster_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_CascadeMaster_LT_Module5");
      getfiltersApi("tblScenario_CascadeMaster_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_CascadeMaster_LT_Module6");
      getfiltersApi("tblScenario_CascadeMaster_LT_Module6");
    } else {
      setTableName("tblScenario_CascadeMaster_LT");
      getfiltersApi("tblScenario_CascadeMaster_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const handleChangeSelectFacilityCode = (event: any) => {
    setSelectFacilityDescription("");
    setSelectFlag("");
    setSelectCascade("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectFacilityCode(value);
    filterRequest[1].value = value;
    callTableGridApi();
    code = 1;
    cascade = 0;
    description = 0;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectCascade = (event: any) => {
    setSelectFlag("");
    const {
      target: { value },
    } = event;
    setSelectCascade(value);
    filterRequest[3].value = value;
    filterRequest[4].value = "";
    callTableGridApi();
    code = 1;
    cascade = 1;
    description = 1;
    type = 1;
    flag = 0;
  };

  // need to change these values
  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        facility_Type: "",
        facility_Code: "",
        facility_Description: "",
        cascade: "",
        flag: 0,
        max_Shift: 0,
        step_up_Cost: 0,
        fix_Cost: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleChangeSelectFacilityDescription = (event: any) => {
    setSelectCascade("");
    setSelectFlag("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectFacilityDescription(value);
    filterRequest[2].value = value;
    callTableGridApi();
    code = 1;
    cascade = 0;
    description = 1;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectFacilityType = (event: any) => {
    setSelectFacilityDescription("");
    setSelectFacilityCode("");
    setSelectFlag("");
    setSelectCascade("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectFacilityType(value);
    filterRequest[0].value = value;
    callTableGridApi();
    code = 0;
    cascade = 0;
    description = 0;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectFlag = (event: any) => {
    code = 1;
    cascade = 1;
    description = 1;
    type = 1;
    flag = 1;
    const {
      target: { value },
    } = event;
    setSelectFlag(value);
    filterRequest[4].value = value;
    callTableGridApi();
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_CASCADE_MASTER_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    console.log(requestParam, "params");

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_CASCADE_MASTER_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);

          setRows(response.data);
          if (cascade === 0) {
            setCascadeOptions(loadFacilityCascadeOptions(response.data));
          }
          if (code === 0) {
            setFacilityCodeOptions(loadFacilityCodeOptions(response.data));
          }
          if (description === 0) {
            setFacilityDescriptionOptions(
              loadFacilityDescriptionOptions(response.data)
            );
          }
          if (type === 0) {
            setFacilityTypeOptions(loadFacilityTypeOptions(response.data));
          }
          if (flag === 0) {
            setFlagOptions(loadflagOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFacilityCodeOptions = (data: any) => {
    const facilityCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = facilityCodeOptions.find((obj: any) => {
        return obj.facility_Code === item.facility_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityCodeOptions.push({
          id: item.id,
          facility_Code: item.facility_Code,
        });
      }
    });
    return facilityCodeOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadFacilityDescriptionOptions = (data: any) => {
    const facilityDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = facilityDescriptionOptions.find((obj: any) => {
        return obj.facility_Description === item.facility_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityDescriptionOptions.push({
          id: item.id,
          facility_Description: item.facility_Description,
        });
      }
    });
    return facilityDescriptionOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadFacilityCascadeOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.cascade === item.cascade;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, cascade: item.cascade });
      }
    });
    return factoryOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadFacilityTypeOptions = (data: any) => {
    console.log(data, "basepack");
    const facilityTypeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = facilityTypeOptions.find((obj: any) => {
        return obj.facility_Type === item.facility_Type;
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityTypeOptions.push({
          id: item.id,
          facility_Type: item.facility_Type,
        });
      }
    });
    return facilityTypeOptions;
  };

  const loadflagOptions = (data: any) => {
    const facilityDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = facilityDescriptionOptions.find((obj: any) => {
        return obj.flag === item.flag;
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityDescriptionOptions.push({ id: item.id, flag: item.flag });
      }
    });
    return facilityDescriptionOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_CASCADE_MASTER_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setIsProcessed(true);
          setRows(response.data);
          setFacilityCodeOptions(loadFacilityCodeOptions(response.data));
          setFacilityTypeOptions(loadFacilityTypeOptions(response.data));
          setFlagOptions(loadflagOptions(response.data));
          setCascadeOptions(loadFacilityCascadeOptions(response.data));
          setFacilityDescriptionOptions(
            loadFacilityDescriptionOptions(response.data)
          );
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //  // callTableGridApi();
  //   getfiltersApi();
  // }, [
  //   selectedFolderId,
  //   selectedScenarioId,
  //   tableName,
  // ]);

  const handleRestoreClicked = (e: any) => {
    setSelectFacilityCode("");
    setSelectFacilityType("");
    setSelectFlag("");
    setSelectCascade("");
    setSelectFacilityDescription("");

    // getfiltersApi();
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "facility_Type",
      "facility_Code",
      "facility_Description",
      "cascade",
      "flag",
      "max_Shift",
      "step_up_Cost",
      "fix_Cost",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //const urls = API_BASE_URL + BULK_EDIT_MANUFACTURING_MASTER_TABLE_API;

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_CASCADE_UPDATE_DATA_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };
    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited CascadeMaster table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Cascade Master"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Cascade Master</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            {/* <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`add-row-span ${!isEditEnabled ? "disabled" : ""}`}
                  onClick={isEditEnabled ? handleAddRow : undefined}
                >
                  <img src={plusIcon} alt="" /> <span>Add Row</span>
                </div>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Type</InputLabel> */}
                {/* <InputLabel>Facility Code</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectFacilityType}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectFacilityType}
                  // renderValue={(selectFacilityType: any) => selectFacilityType}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Type</em>
                  </MenuItem>
                  {facilityTypeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Type}>
                        {d.facility_Type}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Code</InputLabel> */}
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFacilityCode}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFacilityCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Code</em>
                  </MenuItem>
                  {facilityCodeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Code}>
                        {d.facility_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Description</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectFacilityDescription}
                  placeholder="Select Line"
                  onChange={handleChangeSelectFacilityDescription}
                  // renderValue={(selectFacilityDescription: any) => selectFacilityDescription}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Description</em>
                  </MenuItem>
                  {facilityDescriptionNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Description}>
                        {d.facility_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Cascade</InputLabel> */}
                {/* <InputLabel>Facility Type</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectCascade}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectCascade}
                  // id="simple-select-4"
                  // value={selectFacilityType}
                  // placeholder="Select Basepack"
                  // onChange={handleChangeSelectFacilityType}
                  // renderValue={(selectFacilityType: any) => selectFacilityType}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Cascade</em>
                  </MenuItem>
                  {cascadeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.cascade}>
                        {d.cascade}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectflag}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectFlag}
                  // renderValue={(selectflag: any) => selectflag}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Flag</em>
                  </MenuItem>
                  {flagOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.flag}>
                        {d.flag}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <CascadeMasterTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default CascadeMaster;
